export default class Batch {
  /**
   * Create new batch and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get maturityDate () {
    return this._maturityDate
  }

  /**
   * @param {string} value
   */
  set maturityDate (value) {
    this._maturityDate = new Date(value)
  }
}
